import { type ReactNode } from 'react';
import Typography from '@mui/material/Typography';

/** The page h1. `tabIndex={-1}` lets route changes move focus here (A11Y-010). */
export function PageHeading({ children }: { children: ReactNode }) {
  return (
    <Typography variant="h1" component="h1" tabIndex={-1} sx={{ mb: 2 }}>
      {children}
    </Typography>
  );
}
